<template>
  <div
    class="modal fade createNewModal"
    id="AddForumModal"
    tabindex="-1"
    ref="addForumModalRef"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25">
          <h5 class="modal-title fw-bold text-black">{{ title }}</h5>
        </div>
        <div class="modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25">
          <Form ref="forumForm" @submit="addForum" :validation-schema="forumSchema">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Nom <span class="text-danger">*</span>
                  </label>
                  <Field name="nom" type="text" 
                  class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le nom"/>
                  <ErrorMessage name="nom" class="text-danger"/>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Description <span class="text-danger">*</span>
                </label>
                <Field name="description"
                rows="2" as="textarea" placeholder="Description" v-slot="{ field}" class="form-control shadow-none rounded-0 text-black">
                  <textarea
                    v-model="field.value"
                    class="form-control shadow-none rounded-0 text-black"
                  ></textarea>
                </Field>
                <ErrorMessage name="description" class="text-danger"/>
              </div>
              </div>
             
              <div class="col-md-12">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="d-block text-black fw-semibold mb-10">
                      Utilisateurs <span class="text-danger">*</span>
                    </label>
                    <Field  name="users"  v-slot="{ field }">
                      <Multiselect
                        :options="usersOptions"
                        :searchable="true"
                         mode="tags"
                        track-by="label"
                        label="label"
                        v-model = "field.value"
                        v-bind = "field"
                        placeholder="Sélectionner les utilisateurs"
                      />
                    </Field>  
                  </div>
                  <ErrorMessage name="users" class="text-danger"/>
                </div>
              
            <button
              class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
              type="submit"
            >
            {{ btntext }}
            </button>
          </div>
        </Form>
        </div>
        <button
          type="button"
          class="btn-close shadow-none"
          data-bs-dismiss="modal"
          aria-label="Close"
          @click="resetValue()"
        ></button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import ApiService from '../../services/ApiService';
import * as Yup from 'yup';
import { Forum } from '../../models/Forum';
import { error , success, hideModal } from '../../utils/utils';
import axios from 'axios';
import Multiselect from '@vueform/multiselect';

export default defineComponent({
    name: "AddForumModal",
    components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect
   
  },
  props: {
    item: {
      type: Number,
      default: 0,
    }
  },
  setup(props, { emit }){
    const forumSchema = Yup.object().shape({
      nom: Yup.string().required('Le nom est obligatoire'),
      description: Yup.string().required('La description est obligatoire'),
     users: Yup.array()
    .of(Yup.string().required())
    .min(1, 'Au moins un utilisateur est obligatoire'),
    });

    const forumForm = ref<Forum | null>(null);
    const addForumModalRef = ref<null | HTMLElement>(null);
    
    const localItem = ref(props.item);
    const isUPDATE = ref(false);
    const title = ref("Ajouter un forum");
    const btntext = ref('Ajouter');
  
    const usersOptions = ref([]);

    watch(() => props.item, (newValue) => {
      getForum(newValue);
      isUPDATE.value = true;
      btnTitle();
    });

    const btnTitle = async () => {
      if (isUPDATE.value) {
         title.value = "Modifier le forum";
         btntext.value = "Modifier";
      }else{
         title.value = "Ajouter un forum";
         btntext.value = "Ajouter";
      }
    }

    const getForum = async (id: number) => {
      return ApiService.get("/forums/"+id)
      .then(({ data }) => {
        // map data in form
        const donnees = data.data;
        for (const key in donnees) {
          forumForm.value?.setFieldValue(key, 
          (typeof donnees[key] === 'object' && donnees[key] !== null)? donnees[key].id :donnees[key]
          );
        }
        emit('openmodal', addForumModalRef.value);

      })
      .catch(({ response }) => {
        error(response.data.message)
      });
    }


    const fetchUser = async () => {
      try {
        const response = await axios.get('/users');
        const usersData = response.data.data.data;
        usersOptions.value = usersData.map((users) => ({
          value: users.id,
          label: `${users.nomComplet}`,
        }));
      } catch (error) {
        //
      }
    };


    onMounted(()=> {
       fetchUser();
    })

  
    const addForum = async (values: any, forumForm) => {
      values = values as Forum;
      if(isUPDATE.value){
        ApiService.put("/forums/"+values.id,values)
        .then(({ data }) => {
            if(data.code == 200) { 
              success(data.message);
              forumForm.resetForm();
              hideModal(addForumModalRef.value);
              isUPDATE.value=false;
              btnTitle();
              emit('close');
            }
        })
        .catch(({ response }) => {
            error(response.data.message);
        });
      }else{
        ApiService.post("/forums",values)
        .then(({ data }) => {
            if(data.code == 201) { 
              success(data.message);
              forumForm.resetForm();
              hideModal(addForumModalRef.value);
              emit('close');
            }
        })
        .catch(({ response }) => {
            error(response.data.message);
        });
      }
    };

    const resetValue = () => {
      const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
        isUPDATE.value=false;
      formFields.forEach(field => {
        field.value = '';
      });
      btnTitle()
    };

    return { forumSchema,
      addForumModalRef,
      addForum,
      forumForm,usersOptions,
      title,btntext,resetValue
    };
  },
});
</script>